export const PLAYER_JOINED = "PLAYER_JOINED";
export const PLAYER_LEFT = "PLAYER_LEFT";
export const CONNECTED_TO_PEERS = "CONNECTED_TO_PEERS";
export const PEER_ACTION = "PEER_ACTION";
